<template>
  <transition-group class="Overlay-Manager" name="Anim-Overlay-Manager" tag="ul">
    <li class="Overlay-Manager__item" :class="get_colorClass(message.color)" v-for="message in get_messages" :key="message.id" >
      <ButtonClose class="Overlay-Manager__close" :type="'overlay'" @click="removeMessage(message.id)"/> {{ message.text }}
    </li>
  </transition-group>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  //---------------------------------
  import ButtonClose from '@ui/Buttons/ButtonClose/ButtonClose.vue';
  //---------------------------------
  const store = useStore();
  //---------------------------------
  //Получить список активных сообщений
  const get_messages = computed(() => store.state.OverlayManagerSystem.messages);
  //Получить модификатор цвета сообщения
  const get_colorClass = (color) => { 
    return color ? `Overlay-Manager__item--${color}` : '' 
  };
  //---------------------------------
  //Убрать всплывающее сообщение
  const removeMessage = (id) => {
    store.commit('OverlayManagerSystem/toRemoveItem', id);
  }
</script>

<style scoped lang="scss">
  @import './styles/_conf';
</style>